import { Component } from '@angular/compiler/src/core';

export enum PageActions {
  LOAD_MENU_ITEMS = '[Page] Load menu items',
  SET_BANNER_COMPONENT = '[Page] Set banner component',
  NAVIGATE_TO = '[Page] Navigate to',
  OPEN_DIALOG = '[Page] Open Dialog',
  CLOSE_DIALOG = '[Page] Close Dialog',
  OPEN_SNACKBAR = '[Page] Open Snackbar',
  CLOSE_SNACKBAR = '[Page] Close Snackbar',
}

export interface PageMenuItem {
  target: string;
  label: string;
}

export interface PageState {
  menu_items: PageMenuItem[];
  banner_component: Component | string;
  banner_subtitle?: string;
  navigateTo?: string;
}


export interface IMenuItem {
  label: string;
  route?: string;
  onClick?: () => void;
  asHTML?: boolean;
  children?: IMenuItem[];
  routeParams?: { [key: string]: string | number };
  icon?: string;
  hasToggle?: boolean;
  toggleValue?: boolean;
}

export interface IToggleLeftMenuPayload {
  opened: boolean;
}

export const TOGGLE_LEFT_MENU_TYPE = 'toggle-left-menu';